<template>
    <div class="form-group--border">
        <div class="row">
            <div class="col-12">
                <label class="control-label">Укажите причину удаления из реестра</label>
                <textarea v-model="deleteReason" class="form-control" rows="3"></textarea>
                <div class="invalid-msg" v-if="v$.deleteReason.$error">Поле обязательно для заполнения</div>
            </div>
        </div>
        <div>
            <div class="float-right d-flex align-items-center mt-4">
                <button-component class="btn btn-primary mx-2" v-on:click="confirm">Удалить</button-component>
                <button-component type="button" kind="secondary" class="btn" v-on:click="close">Закрыть</button-component>
            </div>
        </div>
    </div>
</template>

<script>
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import {useVuelidate} from "@vuelidate/core";
  import {required} from "@vuelidate/validators";
  export default {
    name: "DeletePermanentlyReason",
    components: {ButtonComponent},
    emits: ['delete', 'close'],
    data() {
      return {
        deleteReason: ''
      }
    },
    methods: {
      confirm() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          return;
        }
        this.$emit('delete', this.deleteReason, true);
      },
      close() {
        this.$emit('close');
      }
    },
    setup: () => ({v$: useVuelidate()}),
    validations() {
      return {
        deleteReason: {required}
      }
    }
  }
</script>
